import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ops-monthly-accounting',
  templateUrl: './ops-monthly-accounting.component.html',
  styleUrls: ['./ops-monthly-accounting.component.css']
})
export class OpsMonthlyAccountingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  public ShowFilters: boolean = true;
  public buttonName: any = 'Show Filters';

  toggle() {
    this.ShowFilters = !this.ShowFilters;
    if (this.ShowFilters)
      this.buttonName = "Hide Filters";
    else
      this.buttonName = "Show Filters";
  }


}
